export const styles = {
  baseCard: {
    boxShadow: 0,
    width: "100%",
    m: 1,
  },
  graphContainer: {
    ml: 1,
    mt: 2,
    p: 1,
    height: "19rem",
    boxShadow: 0,
  },
}
